import React from "react";
import { Outlet } from "react-router-dom";
import ContactHeader from "./ContactHeader";


const ContactLayout = () => {
  return (
    <>
      <ContactHeader />
      <Outlet />
    </>
  );
};

export default ContactLayout;